'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ToggleOff = function ToggleOff(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 9 2' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M8 2H1c-.6 0-1-.4-1-1 0-.5.4-1 1-1h7c.5 0 1 .4 1 1s-.4 1-1 1z', className: 'st0' })
    )
  );
};
/*eslint-enable */

exports.default = ToggleOff;
//# sourceMappingURL=ToggleOff.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/ToggleOff.js